exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".govuk-table__cell--break-word {\n  word-break: break-all;\n}\n", ""]);

// exports
